import { useSyncExternalStore } from 'react';
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
function subscribeToReducedMotion(onChange) {
    const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    mediaQuery.addEventListener('change', onChange);
    return () => mediaQuery.removeEventListener('change', onChange);
}
function readPrefersReducedMotion() {
    return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}
function readPrefersReducedMotionOnServer() {
    return false;
}
export function useReducedMotion() {
    return useSyncExternalStore(subscribeToReducedMotion, readPrefersReducedMotion, readPrefersReducedMotionOnServer);
}
//# sourceMappingURL=useReducedMotion.js.map